"use client"

import { iconsMap } from "@/public/icons/iconsMap"
import { Button } from "@mui/material"
import { getNonUmbracoUrl } from "utils"

const OutlinedButtonWithArrow = ({
  children,
  className,
  href,
  ...props
}: {
  children: React.ReactNode
  [key: string]: any
}) => {
  const ArrowIcon = iconsMap.left_red_arrow

  return (
    <Button
      className={className}
      href={getNonUmbracoUrl(href)}
      variant="outlined"
      {...props}
    >
      {children}
      <ArrowIcon />
    </Button>
  )
}

export default OutlinedButtonWithArrow
